import React__default from 'react';

var ChatActionsContext = React__default.createContext({
  messageAction: undefined
}); // Consumer

var ChatActionsConsumer = ChatActionsContext.Consumer; // Provider

var ChatActionsProvider = function ChatActionsProvider(_a) {
  var children = _a.children,
      messageAction = _a.messageAction;
  return React__default.createElement(ChatActionsContext.Provider, {
    value: {
      messageAction: messageAction
    }
  }, children);
};

export { ChatActionsConsumer, ChatActionsContext, ChatActionsProvider };
//# sourceMappingURL=index.js.map
